import { render, staticRenderFns } from "./AutoSuggest.vue?vue&type=template&id=022cd294&"
import script from "./AutoSuggest.vue?vue&type=script&lang=ts&"
export * from "./AutoSuggest.vue?vue&type=script&lang=ts&"
import style0 from "./AutoSuggest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports